import { api } from "./api";

export interface AnnouncementDto {
    id: string;
    entityId: string;
    title: string;
    content: string;
    publishedAt: string;
}

export interface CreateAnnouncementDto {
    title: string;
    content: string;
    publishedAt: string;
}

export interface UpdateAnnouncementDto {
    id: string;
    title: string;
    content: string;
    publishedAt: string;
}

export const announcementApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAnnouncements: builder.query<AnnouncementDto[], string>({
            query: (entityId) => `entity/${entityId}/announcements`,
            providesTags: ['Announcement'],
        }),
        createAnnouncement: builder.mutation<AnnouncementDto, { entityId: string; data: CreateAnnouncementDto }>({
            query: ({ entityId, data }) => ({
                url: `entity/${entityId}/announcements`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Announcement'],
        }),
        updateAnnouncement: builder.mutation<void, { entityId: string; id: string; data: UpdateAnnouncementDto }>({
            query: ({ entityId, id, data }) => ({
                url: `entity/${entityId}/announcements/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Announcement'],
        }),
        deleteAnnouncement: builder.mutation<void, { entityId: string; id: string }>({
            query: ({ entityId, id }) => ({
                url: `entity/${entityId}/announcements/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Announcement'],
        }),
    }),
});

export const {
    useGetAnnouncementsQuery,
    useCreateAnnouncementMutation,
    useUpdateAnnouncementMutation,
    useDeleteAnnouncementMutation,
} = announcementApi;
